/**
 * FAIR Button — Figma Button (1:2847)
 */

export const FAIR_BUTTON_V1_VARIANTS = [
  'primary',
  'secondary',
  'flat',
  'flat-action',
  'gradient',
] as const

export type FairButtonV1Variant = (typeof FAIR_BUTTON_V1_VARIANTS)[number]

export const FAIR_BUTTON_PHASE2_VARIANTS = [
  'tonal',
  'tonal-action',
  'glass',
  'outlined',
  'outlined-action',
] as const

export type FairButtonPhase2Variant = (typeof FAIR_BUTTON_PHASE2_VARIANTS)[number]

export const FAIR_BUTTON_VARIANTS = [
  ...FAIR_BUTTON_V1_VARIANTS,
  ...FAIR_BUTTON_PHASE2_VARIANTS,
] as const

export type FairButtonVariant = (typeof FAIR_BUTTON_VARIANTS)[number]

export const FAIR_BUTTON_STATES = [
  'idle',
  'hovered',
  'pressed',
  'disabled',
] as const

export type FairButtonPreviewState = (typeof FAIR_BUTTON_STATES)[number]

export const FAIR_BUTTON_THEMES = ['light', 'dark'] as const
export type FairButtonTheme = (typeof FAIR_BUTTON_THEMES)[number]

/** Figma Button: icon-only M = 40px (12+16+12), L = 44px (12+20+12) */
export const FAIR_BUTTON_ICON_SIZE = {
  medium: 16,
  small: 12,
  mobile: 16,
  m: 16,
  l: 20,
} as const
